import React from 'react';
import '../Shared/FormStyles.scss';
import './BookingDetail.scss';

const BookingDetail = ({ booking, onStatusUpdate, onDelete, onClose }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  };

  const formatTime = (time) => {
    const [hours, minutes] = time.split(':');
    const hour = parseInt(hours);
    const period = hour >= 12 ? 'PM' : 'AM';
    const displayHour = hour > 12 ? hour - 12 : hour === 0 ? 12 : hour;
    return `${displayHour}:${minutes} ${period}`;
  };

  const getStatusBadge = (status) => {
    const statusColors = {
      pending: '#f39c12',
      confirmed: '#27ae60',
      cancelled: '#e74c3c',
      completed: '#3498db',
    };

    return (
      <span
        className="status-badge-large"
        style={{ backgroundColor: statusColors[status] || '#95a5a6' }}
      >
        {status.charAt(0).toUpperCase() + status.slice(1)}
      </span>
    );
  };

  return (
    <div className="booking-detail">
      <div className="detail-header">
        <h3>Booking Details</h3>
        <button className="close-btn" onClick={onClose}>✕</button>
      </div>

      <div className="detail-content">
        <div className="detail-section">
          <h4>Booking Information</h4>
          <div className="detail-item">
            <span className="label">Booking ID:</span>
            <span className="value">#{booking._id.slice(-8)}</span>
          </div>
          <div className="detail-item">
            <span className="label">Status:</span>
            <span className="value">{getStatusBadge(booking.status)}</span>
          </div>
          <div className="detail-item">
            <span className="label">Date:</span>
            <span className="value">{formatDate(booking.appointmentDate)}</span>
          </div>
          <div className="detail-item">
            <span className="label">Time:</span>
            <span className="value">{formatTime(booking.timeSlot)}</span>
          </div>
        </div>

        <div className="detail-section">
          <h4>Patient Information</h4>
          <div className="detail-item">
            <span className="label">Name:</span>
            <span className="value">{booking.patientName}</span>
          </div>
          <div className="detail-item">
            <span className="label">Email:</span>
            <span className="value">
              <a href={`mailto:${booking.email}`}>{booking.email}</a>
            </span>
          </div>
          <div className="detail-item">
            <span className="label">Phone:</span>
            <span className="value">
              <a href={`tel:${booking.phone}`}>{booking.phone}</a>
            </span>
          </div>
        </div>

        {booking.serviceType && (
          <div className="detail-section">
            <h4>Service Details</h4>
            <div className="detail-item">
              <span className="label">Service Type:</span>
              <span className="value">{booking.serviceType}</span>
            </div>
          </div>
        )}

        {booking.reasonForVisit && (
          <div className="detail-section">
            <h4>Reason for Visit</h4>
            <p className="detail-text">{booking.reasonForVisit}</p>
          </div>
        )}

        {booking.notes && (
          <div className="detail-section">
            <h4>Notes</h4>
            <p className="detail-text">{booking.notes}</p>
          </div>
        )}

        {booking.preferredTherapist && (
          <div className="detail-section">
            <h4>Preferred Therapist</h4>
            <p className="detail-text">{booking.preferredTherapist}</p>
          </div>
        )}

        <div className="detail-section">
          <h4>Timestamps</h4>
          <div className="detail-item">
            <span className="label">Booked On:</span>
            <span className="value">{new Date(booking.createdAt).toLocaleString()}</span>
          </div>
          {booking.updatedAt && booking.updatedAt !== booking.createdAt && (
            <div className="detail-item">
              <span className="label">Last Updated:</span>
              <span className="value">{new Date(booking.updatedAt).toLocaleString()}</span>
            </div>
          )}
        </div>
      </div>

      <div className="detail-actions">
        <h4>Update Status</h4>
        <div className="status-buttons">
          {booking.status === 'pending' && (
            <>
              <button
                className="btn-confirm"
                onClick={() => onStatusUpdate(booking._id, 'confirmed')}
              >
                Confirm
              </button>
              <button
                className="btn-cancel"
                onClick={() => onStatusUpdate(booking._id, 'cancelled')}
              >
                Cancel
              </button>
            </>
          )}
          {booking.status === 'confirmed' && (
            <>
              <button
                className="btn-complete"
                onClick={() => onStatusUpdate(booking._id, 'completed')}
              >
                Mark Complete
              </button>
              <button
                className="btn-cancel"
                onClick={() => onStatusUpdate(booking._id, 'cancelled')}
              >
                Cancel
              </button>
            </>
          )}
        </div>
        <button
          className="dashboard-danger-btn btn-primary"
          onClick={() => onDelete(booking._id)}
        >
          Delete Booking
        </button>
      </div>
    </div>
  );
};

export default BookingDetail;
